export default __webpack_public_path__ + "static/media/manila.0ab711c8.png";